/**
 * 全局绑定弹窗状态
 */

import { ref, readonly } from 'vue'

export type BindAccountType = 'phone' | 'wechat'

const visible = ref(false)
const bindType = ref<BindAccountType>('phone')

export function openBindAccountModal(type: BindAccountType) {
  bindType.value = type
  visible.value = true
}

export function closeBindAccountModal() {
  visible.value = false
}

export function useBindAccountModal() {
  return {
    visible: readonly(visible),
    bindType: readonly(bindType),
    openBindAccountModal,
    closeBindAccountModal
  }
}
